import { isMentionAllHandle, mentionTokens } from '@leanin/shared';
import { type useTranslations } from '@/i18n/translations';
import type { MentionAllGroup } from './MentionPopover';

// "You are about to ping the whole group" line shown under a composer whose
// body carries an `@all` token the saved body does not. Reads the same
// mention grammar the server resolves against, and the same new-relative-to-
// previous rule the server's mention delta applies, so the hint appears
// exactly when the write will fan out — including for an `@all` typed by hand
// rather than picked from the suggestion list, and never for an edit of a
// body that already said `@all` (which notifies nobody again).

type FeedTranslate = ReturnType<typeof useTranslations<'Feed'>>;

function mentionsAll(markdown: string): boolean {
  for (const token of mentionTokens(markdown)) {
    if (isMentionAllHandle(token.handle)) return true;
  }
  return false;
}

/** The hint copy, or null when this write would not notify the group.
 *  @param previousMarkdown the saved body being edited; null when composing
 *  a new post or comment. */
export function mentionAllHint(
  markdown: string,
  previousMarkdown: string | null,
  group: MentionAllGroup,
  t: FeedTranslate,
): string | null {
  if (!mentionsAll(markdown)) return null;
  if (previousMarkdown !== null && mentionsAll(previousMarkdown)) return null;
  return t('composer.mentionAllHint', { group: group.name });
}
